export let CurrencyType;

(function (CurrencyType) {
  CurrencyType[CurrencyType["GTHC"] = 1] = "GTHC";
  CurrencyType[CurrencyType["GTHG"] = 2] = "GTHG";
  CurrencyType[CurrencyType["GPP"] = 3] = "GPP";
  CurrencyType[CurrencyType["GPT"] = 5] = "GPT";
  CurrencyType[CurrencyType["GMQP"] = 6] = "GMQP";
  CurrencyType[CurrencyType["THC"] = 11] = "THC";
  CurrencyType[CurrencyType["THG"] = 12] = "THG";
  CurrencyType[CurrencyType["GOLD"] = 22] = "GOLD";
  CurrencyType[CurrencyType["BUSD"] = 31] = "BUSD";
  CurrencyType[CurrencyType["WBNB"] = 32] = "WBNB";
  CurrencyType[CurrencyType["BUSDT"] = 34] = "BUSDT";
  CurrencyType[CurrencyType["BNB"] = 1000] = "BNB";
})(CurrencyType || (CurrencyType = {}));

export let ItemType;

(function (ItemType) {
  ItemType[ItemType["TOURNAMENT_TICKET"] = 29] = "TOURNAMENT_TICKET";
})(ItemType || (ItemType = {}));